<div class="header">
  <app-header-bar
    title="{{ 'FAQs and Forms' | translate }}"
    [showButton]="false"
  ></app-header-bar>
</div>
<div class="main-primary-card-container">
  <app-primary-card
    size="full"
    title="{{ 'Administration Forms' | translate }}"
    class="main-primary-card"
    headerSize="small"
  >
    <div class="sub-primary-card-container">
      <app-information-card
        title="{{ 'FLI-P administration form' | translate }}"
        class="sub-primary-card"
      >
        <app-action-button
          kind="outline"
          color="primary"
          size="outlined"
          class="action-button"
          (onClick)="openPdf(flipAdministrationForm)"
        >
          {{ 'Open Form' | translate }}
        </app-action-button>
      </app-information-card>
      <app-information-card
        title="{{ 'REDDI administration form' | translate }}"
        subtitle="{{ '(6 Sounds)' | translate }}"
        class="sub-primary-card"
      >
        <app-action-button
          kind="outline"
          color="primary"
          size="outlined"
          class="action-button"
          (onClick)="openPdf(reddiAdministrationForm6sounds)"
        >
          {{ 'Open Form' | translate }}
        </app-action-button>
      </app-information-card>
      <app-information-card
        title="{{ 'REDDI administration form' | translate }}"
        subtitle="{{ '(7 Sounds)' | translate }}"
        class="sub-primary-card"
      >
        <app-action-button
          kind="outline"
          color="primary"
          size="outlined"
          class="action-button"
          (onClick)="openPdf(reddiAdministrationForm7sounds)"
        >
          {{ 'Open Form' | translate }}
        </app-action-button>
      </app-information-card>
    </div>
  </app-primary-card>
</div>
<div class="main-primary-card-container">
  <app-primary-card
    size="full"
    title="{{ 'HearHub FAQ' | translate }}"
    headerSize="small"
  >
    <div class="sub-primary-card-container">
      <app-information-card
        title="{{ 'General HearHub FAQ' | translate }}"
        class="sub-primary-card"
      >
        <app-action-button
          kind="outline"
          color="primary"
          size="outlined"
          class="action-button"
          (onClick)="openPage(generalHearhubFaq)"
        >
          {{ 'Open FAQs' | translate }}
        </app-action-button>
      </app-information-card>
      <app-information-card
        title="{{ 'REDDI FAQ' | translate }}"
        class="sub-primary-card"
      >
        <app-action-button
          kind="outline"
          color="primary"
          size="outlined"
          class="action-button"
          (onClick)="openPage(generalReddiFaq)"
        >
          {{ 'Open FAQs' | translate }}
        </app-action-button>
      </app-information-card>
      <app-information-card
        title="{{ 'FLI-P FAQ' | translate }}"
        class="sub-primary-card"
      >
        <app-action-button
          kind="outline"
          color="primary"
          size="outlined"
          class="action-button"
          (onClick)="openPage(generalFlipFaq)"
        >
          {{ 'Open FAQs' | translate }}
        </app-action-button>
      </app-information-card>
      <app-information-card
        title="{{ 'Courses FAQ' | translate }}"
        class="sub-primary-card"
      >
        <app-action-button
          kind="outline"
          color="primary"
          size="outlined"
          class="action-button"
          (onClick)="openPage(generalCoursesFaq)"
        >
          {{ 'Open FAQs' | translate }}
        </app-action-button>
      </app-information-card>
    </div>
  </app-primary-card>
</div>
